import Props from "./Properties"
import {DimensionProperties} from './PropertyTemplates.js'
import LocationInfo from "./LocationInfo"

class Dimension
{
    readonly id: string;
    name: string;
    rating: number;
    description: string;
    showHomePage: boolean;
    properties: any[] = [];
    locations: LocationInfo[] = [];
    locationsMap: {[key: string] : LocationInfo; } = {};

    constructor(data: any) {
        if (!data) {
            throw "Null data for Dimension";
        }
        this.id = data.id;
        this.name = data.name ? data.name : this.id;
        this.rating = 4;
        this.description = data.description ? data.description : '';
        this.showHomePage = !!data.show_home_page;
        this.properties = Props.parse(DimensionProperties, data);
        if (data.locations) {
            for (const [id, locInfo] of Object.entries(data.locations)) {
                let loc = new LocationInfo(locInfo);
                this.locations.push(loc);
                this.locationsMap[loc.id] = loc;
            }
            this.locations.sort((a, b) => { return a.name < b.name ? -1 : 1 })
        }
    }

}

export default Dimension;
